<script setup lang="ts">
import Notifications from "@/components/layout/Notifications.vue";
import ThemeProvider from "@/components/layout/ThemeProvider.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
</script>

<template>
  <div id="main">
    <ThemeProvider>
      <LoadingOverlay>
        <RouterView />
      </LoadingOverlay>
      <Notifications />
    </ThemeProvider>
  </div>
</template>
